module.exports = __webpack_public_path__ + "static/media/after_sales_active.189868f6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/objects/after_sales_active.svg
// module id = 1091
// module chunks = 36